import { stateOptions } from '../../../../shared/helper/states'

export default {
  name: 'Coapplicant',

  // language=HTML (for PhpStorm)
  template: `
    <ui-form-partial label="Co-Applicant/Spouse Information">
      <p class="disclaimer">
        Co-Applicant must be 18 years old or older. By adding this person as a co-applicant
        you are giving this person authorization to discuss the account with Rutherford EMC.
        Co-Applicants will be able to ask questions regarding the account, make payment
        arrangements, authorize connects/disconnects/reconnects on the account, etc.
      </p>
      
      <ui-form-item label="First Name" prop="coapplicant.firstName">
        <ui-form-input name="coapp_fname" v-model="model.coapplicant.firstName" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Middle Name" prop="coapplicant.middleName">
        <ui-form-input name="coapp_mname" v-model="model.coapplicant.middleName" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Last Name" prop="coapplicant.lastName">
        <ui-form-input name="coapp_lname" v-model="model.coapplicant.lastName" input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Birth Date" prop="coapplicant.dateOfBirth">
        <ui-date-picker-input v-model="model.coapplicant.dateOfBirth" />
      </ui-form-item>

      <ui-form-item label="Social Security Number" prop="coapplicant.ssn">
        <ui-form-input name="coapp_ssn" v-model="model.coapplicant.ssn" input-class="width--small" />
      </ui-form-item>

      <br>
      <ui-form-item label="Drivers License Number" prop="coapplicant.driversLicense.number">
        <ui-form-input
          name="coapp_dl_num"
          v-model="model.coapplicant.driversLicense.number"
          input-class="width--small" />
      </ui-form-item>

      <ui-form-item label="Issuing State" prop="coapplicant.driversLicense.state">
        <ui-form-select
          name="coapp_dl_state"
          v-model="model.coapplicant.driversLicense.state"
          :options="stateOptions"
          input-class="inline" />
      </ui-form-item>
    </ui-form-partial>
  `,

  props: {
    model: Object,
  },

  computed: {
    stateOptions() {
      return stateOptions
    },
  },
}
